module.exports = __webpack_public_path__ + "static/media/9.51cb708e.jpg";